var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-wrap",class:_vm.theme},[_c('t-checkbox',{staticClass:"checkbox",attrs:{"value":_vm.value,"disabled":_vm.disabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }